import type {
    ProdutoAdicionalItemStatus,
    ProdutoAdicionalStatus,
} from '@/features/produto-adicional/types/enum';
import { BadgeOnOff } from '@/components/revisar/badge/BadgeOnOff';

export function ProdutoTabAdicionalStatus({
    status,
}: {
    status: ProdutoAdicionalStatus | ProdutoAdicionalItemStatus;
}) {
    return <BadgeOnOff status={status === 1 ? 'success' : status === 2 ? 'error' : 'default'} />;
}
